import React from "react";
import { Box, Paper, Stack, Tooltip, Typography } from "@mui/material";
import {
  EmailOutlined,
  MessageOutlined,
  WhatsApp,
} from "@mui/icons-material";

import {
  cardHeaderSx,
  dispatchConfigCardSx,
  dispatchConfigCardsRowSx,
  dispatchConfigSectionSx,
  dispatchConfigTitleSx,
  detailsChannelsBlockSx,
  detailsMetricItemSx,
  detailsMetricsRowSx,
  detailsMetricValueContentSx,
  descriptionValueSx,
  infoCardSx,
  labelSx,
  metricValueIconSx,
  metricValueRowSx,
  sectionTitleSx,
  valueSx,
  badgeSx,
} from "../CampaignViewPage.styles";
import {
  formatCampaignStatus,
  getCampaignStatusMeta,
} from "../CampaignViewPage.utils";
import StatusIcon from "../../../../shared/components/StatusLabel/StatusIcon";

export default function CampaignDetailsCard({
  campaignMetrics,
  dispatchSettings = [],
  status,
  channels,
}) {
  const campaignStatus = formatCampaignStatus(status);
  const campaignStatusMeta = getCampaignStatusMeta(campaignStatus);
  const visibleChannels = channels.filter((channel) => Boolean(channel.value));
  const channelIcons = {
    WhatsApp: <WhatsApp sx={{ width: 24, height: 24, color: "#25D366" }} />,
    SMS: <MessageOutlined sx={{ width: 24, height: 24, color: "#2563eb" }} />,
    "E-mail": <EmailOutlined sx={{ width: 24, height: 24, color: "#0ea5e9" }} />,
  };

  return (
    <Paper sx={infoCardSx}>
      <Box sx={cardHeaderSx}>
        <Typography sx={sectionTitleSx}>Detalhes da campanha</Typography>

        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            background: campaignStatusMeta.color,
            borderRadius: 2,
            px: 2,
            py: 1,
          }}
        >
          <StatusIcon
            status={campaignStatusMeta.icon}
            color={"#ffffff"}
            width="20px"
            height="20px"
          />
          <Typography sx={{ ...badgeSx }}>
            {campaignStatusMeta.label}
          </Typography>
        </Stack>
      </Box>

      <Box sx={detailsMetricsRowSx}>
        {visibleChannels.length &&
          visibleChannels.map((channel) => (
            <Box
              key={channel.label}
              sx={{ ...detailsMetricItemSx, ...detailsChannelsBlockSx }}
            >
              <Typography sx={labelSx}>{channel.label}</Typography>
              <Box sx={metricValueRowSx}>
                <Box sx={metricValueIconSx}>
                  {channelIcons[channel.label] || (
                    <MessageOutlined sx={{ width: 24, height: 24 }} />
                  )}
                </Box>
                <Box sx={detailsMetricValueContentSx}>
                  <Tooltip title={channel.value || ""} arrow placement="top-start">
                    <Typography sx={descriptionValueSx}>{channel.value}</Typography>
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          ))}
        {campaignMetrics.map((item) => (
          <Box key={item.label} sx={{ ...detailsMetricItemSx, ...item.itemSx }}>
            <Typography sx={labelSx}>{item.label}</Typography>
            <Box sx={metricValueRowSx}>
              <Box sx={metricValueIconSx}>{item.icon}</Box>
              <Box sx={detailsMetricValueContentSx}>
                {React.isValidElement(item.value) ? (
                  <Box sx={{ mt: 0.25 }}>{item.value}</Box>
                ) : (
                  <Tooltip title={item.value || ""} arrow placement="top-start">
                    <Typography sx={{ ...valueSx, ...item.valueSx }}>
                      {item.value}
                    </Typography>
                  </Tooltip>
                )}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      <Box sx={dispatchConfigSectionSx}>
        <Typography sx={dispatchConfigTitleSx}>Configurações de disparo</Typography>

        <Box sx={dispatchConfigCardsRowSx}>
          {dispatchSettings.map((item) => (
            <Box key={item.label} sx={dispatchConfigCardSx}>
              <Typography sx={{ ...valueSx, fontSize: 13, fontWeight: 700 }}>
                {item.label}
              </Typography>
              <Typography sx={{ ...descriptionValueSx, fontSize: 13, lineHeight: 1.45 }}>
                {item.value || "----"}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Paper>
  );
}
